import { useTranslate } from '@tolgee/react';
import ContentLoader from 'react-content-loader';

const InfiniteScrollLoader = (props) => {
  const { t } = useTranslate();

  return (
    <ContentLoader
      speed={4}
      width={200}
      height={15}
      viewBox="0 0 200 15"
      backgroundColor="#f6f5f4"
      foregroundColor="#deddda"
      title={t('communication.skeleton.title')}
      {...props}
    >
      <rect x="2" y="0" rx="0" ry="0" width="200" height="15" />
    </ContentLoader>
  );
};

export default InfiniteScrollLoader;
